import { ChangeDetectionStrategy, Component, EventEmitter, Output, inject } from '@angular/core'

import {
  FLX_MODAL_DATA,
  FlxButtonModule,
  FlxModalModule,
  FlxModalService,
} from '@flowx/angular-ui-toolkit'
import { DataModelResourceType } from '@flowx/designer/shared/api/data-model.api'

import {
  DataModelAttribute,
  DataModelReference,
} from '../../../core/dictionary/data-model.dictionary'
import { AttributeReferencesComponent } from '../attribute-references/attribute-references.component'

@Component({
  selector: 'flx-edit-attribute-confirmation-modal',
  imports: [FlxModalModule, FlxButtonModule, AttributeReferencesComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './edit-attribute-confirmation-modal.component.html',
})
export class EditAttributeConfirmationModalComponent {
  #modalService = inject(FlxModalService)
  @Output() dataEventEmitter = new EventEmitter<void>()

  data = inject<{
    resourceType: DataModelResourceType
    attribute: DataModelAttribute
    references: DataModelReference[]
  }>(FLX_MODAL_DATA)

  closeModal(): void {
    this.#modalService.hide()
  }

  confirm(): void {
    this.dataEventEmitter.emit()
  }
}
